import DomainResource from './DomainResource';
import merge from 'lodash/merge';

/**
 * The account's face sheet settings, stored at the fixed id `face-sheet`. `items` holds the keys
 * of the items Print face sheet prints, in print order (see client/src/common/faceSheet.js), and
 * `vitalsHistoryDays` how many days of vitals its Vitals section prints.
 */
export default class BN_FaceSheetConfig extends DomainResource {
    static _className = 'BN_FaceSheetConfig';

    _objectStructure = {
        items: [String],
        vitalsHistoryDays: Number,
    };

    constructor(constructJson, className = 'BN_FaceSheetConfig') {
        super(constructJson, className);
        this.createAndPopulateStructure(this._objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this._objectStructure));
    }
}
